import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-550b80c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "right fas fa-angle-left"
}
const _hoisted_2 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([{'menu-open': _ctx.isMenuExtended}, "nav-item"])
  }, [
    _createElementVNode("a", {
      class: _normalizeClass([{active: _ctx.isMainActive || _ctx.isOneOfChildrenActive}, "nav-link"]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMainMenuAction && _ctx.handleMainMenuAction(...args)))
    }, [
      _createElementVNode("i", {
        class: _normalizeClass('nav-icon fas ' + _ctx.menuItem.icon)
      }, null, 2),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.menuItem.name)), 1),
      (_ctx.isExpandable)
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : _createCommentVNode("", true)
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItem.children, (item) => {
      return (_openBlock(), _createElementBlock("ul", {
        key: item.path,
        class: "nav nav-treeview"
      }, [
        _createElementVNode("li", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: item.path,
            class: "nav-link",
            exact: "",
            "exact-active-class": "active"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass('far' + item.icon + 'nav-icon')
              }, null, 2),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.name)), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      ]))
    }), 128))
  ], 2))
}